import React from 'react';
import { Piano, Music, Award, Sparkles } from 'lucide-react';

const PianoGallery = () => {
  const pianoCategories = [
    {
      title: "Pianos Numériques",
      description: "Technologie moderne avec toucher authentique",
      icon: Music,
      image: "https://images.pexels.com/photos/164743/pexels-photo-164743.jpeg?auto=compress&cs=tinysrgb&w=1200",
      brands: ["Yamaha", "Kawai", "Schimmel"],
      features: ["Échantillonnage haute qualité", "Connectivité moderne", "Entretien régulier", "Neufs et occasions disponibles"]
    },
    {
      title: "Pianos Acoustiques à Queue/Droit",
      description: "Acoustique traditionnelle des grandes manufactures",
      icon: Piano,
      image: "https://images.pexels.com/photos/5070054/pexels-photo-5070054.jpeg?auto=compress&cs=tinysrgb&w=1200",
      brands: ["Seiler", "Steinberg", "May"],
      features: ["Son acoustique authentique", "Artisanat traditionnel", "Investissement durable", "Neufs et occasions disponibles"]
    }
  ];

  const brandShowcase = [
    {
      brand: "YAMAHA",
      image: "https://images.pexels.com/photos/164743/pexels-photo-164743.jpeg?auto=compress&cs=tinysrgb&w=800",
      features: ["Technologie CFX", "Toucher authentique", "Connectivité moderne", "Gamme complète disponible"]
    },
    {
      brand: "KAWAI",
      image: "/imageskawai.jpeg",
      features: ["Grand Feel III", "Touches en bois", "Son Shigeru Kawai", "Partenaire historique"]
    },
    {
      brand: "ADAGIO",
      image: "/adagio.jpg",
      features: ["Tradition allemande", "Qualité premium", "Design élégant", "Savoir-faire artisanal"]
    }
  ];

  return (
    <section id="pianos" className="section-modern relative" style={{ zIndex: 5 }}>
      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center mb-20 scroll-reveal relative z-5">
          <h2 className="text-5xl md:text-6xl font-light heading-modern mb-6">
            Notre <span className="heading-accent">Collection</span>
          </h2>
          <p className="text-xl text-white/70 font-light max-w-3xl mx-auto leading-relaxed mb-8">
            Découvrez notre sélection exquise de pianos neufs et d'occasion,
            chacun choisi pour sa qualité exceptionnelle et son caractère unique.
          </p>
          <div className="glass-card rounded-2xl p-6 max-w-4xl mx-auto mb-8">
            <p className="text-white/80 font-light leading-relaxed">
              <span className="text-yellow-400 font-semibold">Partenaire KAWAI depuis des décennies</span> -
              Nous commercialisons cette marque prestigieuse avec expertise et passion.
              D'autres marques sont également disponibles en magasin selon vos besoins spécifiques.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12 relative z-5">
          {pianoCategories.map((category, index) => {
            const IconComponent = category.icon;
            return (
              <div
                key={index}
                className="glass-card rounded-2xl overflow-hidden interactive-card light-effect scroll-reveal relative z-30"
                style={{ zIndex: 40, animationDelay: `${index * 0.2}s` }}
              >
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={category.image}
                    alt={category.title}
                    className="w-full h-full object-cover transition-transform duration-700 hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
                  <div className="absolute top-6 right-6">
                    <div className="p-3 rounded-full bg-white/10 backdrop-blur-sm border border-white/20">
                      <IconComponent className="w-6 h-6 text-accent-gold" />
                    </div>
                  </div>
                </div>

                <div className="p-8">
                  <h3 className="text-2xl font-semibold mb-3 text-white">
                    {category.title}
                  </h3>
                  <p className="text-white/70 mb-6 leading-relaxed">
                    {category.description}
                  </p>

                  <div className="mb-6">
                    <h4 className="text-lg font-semibold text-white mb-3">Marques principales :</h4>
                    <div className="flex flex-wrap gap-2">
                      {category.brands.map((brand, brandIndex) => (
                        <span
                          key={brandIndex}
                          className="bg-yellow-400/20 text-yellow-400 px-3 py-1 rounded-full text-sm font-semibold border border-yellow-400/30"
                        >
                          {brand}
                        </span>
                      ))}
                    </div>
                  </div>

                  <div className="space-y-3 mb-8">
                    {category.features.map((feature, featureIndex) => (
                      <div key={featureIndex} className="flex items-center text-sm text-white/60">
                        <div className="w-1.5 h-1.5 rounded-full bg-accent-gold mr-3 flex-shrink-0" />
                        {feature}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="text-center mt-16 scroll-reveal relative z-5">
          <div className="glass-card rounded-3xl p-8 max-w-4xl mx-auto">
            <p className="text-white/70 mb-6 leading-relaxed">
              Chaque piano est soigneusement sélectionné et préparé par Jean-Claude BUCHTA.
              Nous proposons des instruments neufs et d'occasion pour tous les budgets et tous les niveaux.
            </p>
            <p className="text-white/60 text-sm">
              D'autres marques prestigieuses sont disponibles en magasin.
              N'hésitez pas à nous consulter pour vos besoins spécifiques.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PianoGallery;
